import React from "react";
import Button from "../components/Button/Button";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const ContactCTASection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className="w-full bg-white py-20" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Side: Text + Form */}
        <motion.div
          initial={{ x: -80, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2 className="text-3xl md:text-5xl font-semibold text-gray-900 mb-6">
            Ready to Take Your Customer Experience to the Next Level?
          </h2>
          <p className="text-gray-600 text-lg mb-12">
            Don’t miss out on valuable feedback—start using Zola today to engage with your customers and improve your service, no matter where they are. Get insights instantly, take action quickly, and watch your business grow.
          </p>

          {/* Form */}
          <form className="flex flex-col gap-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                Name
              </label>
              <input
                type="text"
                id="name"
                placeholder="Your name"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#7f56d9]"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                id="email"
                placeholder="you@company.com"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#7f56d9]"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                Message
              </label>
              <textarea
                id="message"
                placeholder="Type your message..."
                rows="4"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#7f56d9]"
              ></textarea>
            </div>

            <Button variant="primary" type="submit" className="w-full">
              Book a demo
            </Button>
          </form>
        </motion.div>

        {/* Right Side: Image */}
        <motion.div
          initial={{ x: 80, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          className="w-full"
        >
          <img
            src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50ccf0181c48602fd6673_Group%201000005173.png"
            alt="Book a Demo"
            className="w-full h-auto object-contain rounded-2xl"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ContactCTASection;
